import { Database } from '@/types/supabase';
import { Region } from './region';
import { District } from './district';

export type UserRow = Database['public']['Tables']['users']['Row'];
export type RoleRow = Database['public']['Tables']['roles']['Row'];

// User model matching Supabase public.users table
export interface User {
  id: string;
  auth_id: string;
  full_name: string | null;
  email: string | null;
  role_id: string | null;
  district_id: string | null;
  region_id: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string | null;

  // Populated from joins (optional)
  role?: Role;
  region?: Region;
  district?: District;
}

export interface Role {
  id: string;
  name: string;
  code: string;
  description: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string | null;
}

// Role codes enum for type safety
export enum RoleCode {
  ADMIN = 'ADMIN',
  DISTRICT_ADMIN = 'DISTRICT_ADMIN',
  REGION_ADMIN = 'REGION_ADMIN',
}

export type UserInput = Omit<User, 'id' | 'created_at' | 'role'>;

/**
 * Check if a user has admin privileges
 */
export function isAdmin(user: User | null): boolean {
  if (!user?.role) return false;
  return user.role.code === RoleCode.ADMIN;
}

/**
 * Check if a user has a specific role code
 */
export function hasRole(user: User | null, roleCode: RoleCode): boolean {
  if (!user?.role) return false;
  return user.role.code === roleCode;
}
